import { OverlayRef } from '@angular/cdk/overlay';
import { Component, HostListener, Inject, InjectionToken, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

export type MediaData = {
  type: PreviewMediaType.Image,
  src: SafeUrl,
}|{
  type: PreviewMediaType.YouTube,
  src: string,
};

export enum PreviewMediaType {
  Image,
  YouTube,
}

export const MEDIA_DATA = new InjectionToken<MediaData>('MEDIA_DATA');

@Component({
    selector: 'app-media-preview',
    templateUrl: './media-preview.component.html',
    styleUrls: ['./media-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MediaPreviewComponent implements OnDestroy {

  src: string|SafeUrl;
  type: PreviewMediaType;

  // Forward enum to template
  PreviewMediaType = PreviewMediaType;

  private subscriptions = new Subscription();

  constructor(
      private readonly overlayRef: OverlayRef,
      @Inject(MEDIA_DATA) data: MediaData,
  ) {
    this.type = data.type;
    this.src = data.src;
    this.subscriptions.add(this.overlayRef.backdropClick().subscribe(() => {
      this.close();
    }));
  }

  @HostListener('document:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  close() {
    this.overlayRef.detachBackdrop();
    this.overlayRef.dispose();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
